import { InputTextarea } from "primereact/inputtextarea";

const SfTextarea = (props) => {
  const classes = props.styling ? props.styling : "text-sm";

  return <InputTextarea {...props} className={classes} />;
};

export default SfTextarea;
